import AxiosAgent from "./AxiosAgent";
import api from "./api";


export const notificationCountForCurrentUser = () => {
    return AxiosAgent.requests.get(
        api.NOTIFICATION + "/count"
    );
};
export const notificationList = data => {
    return AxiosAgent.requests.get(
        api.NOTIFICATION
    );
};

export const notificationList2 = data => {
    return AxiosAgent.requests.post(`${api.NOTIFICATION}?page=${0}&size=${5}`, {});
}